/**
 * Given an amount in cents, returns the same amount in euros
 */
const amountWithMinorCurrency = (amountInCents: number) => amountInCents / 100;

export default amountWithMinorCurrency;
